<template>
  <section>
    <div v-if="routeName === 'hotel'">
			<comingSoon/>
		</div>
    <section v-else>
      <div class="overlay"></div>
      <section class="page-home">
        <div class="page__header text-center">
            <h5 class="page__header--text">Hello!</h5>
            <h4 class="page__header--text">Stay comfortable and enjoy!</h4>
        </div>
        <div class="search__section px-4">
            <div class="search__section--wrapper">
                <div class="hotel-text-div ">
                    <p class="hotel-text">Find Hotels</p>
                </div>
                <!-- one way form  -->
                <section class="form-section d-flex align-items-center justify-content-center mt-4">
                    <div class="flight-from d-flex align-items-center ml-3 py-2 px-3">
                        <div>
                            <img src="@/assets/TAJimages/hotels/building.svg" alt="building">
                        </div>
                        <div class="ml-3 flight-text">
                            <h6 class="ml-2 text-going">Going to?</h6>
                            <h6 v-if="isHotelLoading" class="ml-2 mt-1 text-danger">Please wait...</h6>
                            <div v-else class="search-wrapper" @click="toggleDropDown">
                                <input type="text" v-model="form.destination" class="search-form" placeholder="Search Hotel"/>
                            </div>
                            <!-- <v-select v-else label="airportName" v-model="itineraries.destination" placeholder="Select Destination" :options="allAirports" :reduce="airportName => airportName.airportName"></v-select> -->
                        </div>
                        <div class="airport-wraper-destination animated fadeIn" v-if="isHotelCityDropdown">
                            <div v-for="city in filterHotelCity" :key="city.id" @click="setValue(city)">
                            <p class="my-2" style="font-size:16px">{{ city.cityName }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="button__section d-flex align-items-center ml-2" @click="showDateModal">
                        <div class="flight-date p-3">
                            <section class="d-flex justify-content-between">
                                <div>
                                    <p class="text-class">Check-in <br><span class="text-eco">Date</span></p>
                                </div>
                                <div>
                                  <p v-if="form.checkinDate" class="text-class text-center" style="width:50px">{{ form.checkinDate | formatDate}}</p>
                                  <img v-else src="@/assets/TAJimages/flight/flight-date.png" alt="date">
                                </div>
                            </section>
                        </div>
                    </div>
                    <div class="button__section d-flex align-items-center ml-2" @click="showDateModal">
                        <div class="flight-date p-3">
                            <section class="d-flex justify-content-between">
                                <div>
                                    <p class="text-class">Check-out <br><span class="text-eco">Date</span></p>
                                </div>
                                <div>
                                  <p v-if="form.checkoutDate" style="width:50px" class="text-class text-center">{{ form.checkoutDate | formatDate}}</p>
                                  <img v-else src="@/assets/TAJimages/flight/flight-date.png" alt="date">
                                </div>
                            </section>
                        </div>
                    </div>
                    <section v-if="isDateOpen" class="animated fadeIn date-wrapper my-4">
                        <div class="pb-3 text-right">
                            <button type="button" class="btn btn-danger" @click="setDate">Ok</button>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div>
                                <p class="font-weight-bold">Choose check-in date</p>
                                <DatePicker color="red" v-model="form.checkinDate" :min-date='new Date()'/>
                            </div>
                            <div>
                                <p class="font-weight-bold text-right">Choose check-out date</p>
                                <DatePicker color="red" v-model="form.checkoutDate" :min-date='form.checkinDate'/>
                            </div>
                        </div>
                    </section>
                    <div class="d-flex align-items-center justify-content-between py-4 flight-type" @click="showPassDropdown">
                        <div class="d-flex align-items-center">
                            <h6 class="text-room">Rooms</h6>
                             <img src="@/assets/TAJimages/hotels/building-sm.svg" width="30px" class="px-2" alt="man">
                            <h6 class="text-room font-weight-bold">{{roomInfo.length}}</h6>
                        </div>
                        <div class="d-flex align-items-center">
                            <p class="text-room">Guest</p>
                            <img src="@/assets/TAJimages/hotels/man-sm.svg" width="25px" class="px-2" alt="man">
                            <p class="text-room">{{guestTotal}}</p>
                        </div>
                    </div>
                    <div v-if="isPassengerData" class="animated fadeIn flight-type-menu" >
                      <p @click="showPassDropdown" class="font-weight-bold" style="position: absolute; right:30px">x</p>
                      <section v-for="(info, index) in roomInfo" :key="index">
                        <div class="menu--wrapper d-flex align-items-center justify-content-between flex-wrap">
                          <p class="text-danger font-weight-bold">Room {{ index + 1 }}</p>
                          <p class="text-remove" v-if="index >= 1" @click="deleteRoom">Remove</p>
                        </div>
                        <div class="pass-section">
                            <div>
                                <div class="d-flex justify-content-between">
                                    <div class="pass-text">
                                        <h4>Adults</h4>
                                        <p>&#62; 12 yrs</p>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <div class="minus" @click="decreaseValue(index, 'adults')">-</div>
                                        <span class="mx-3 font-weight-bold">{{info.adults}}</span>
                                        <div class="plus" @click="increaseValue(index, 'adults')">+</div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between my-4">
                                    <div class="pass-text">
                                        <h4>Children </h4>
                                        <p>2 - 12 yrs</p>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <div class="minus" @click="decreaseValue(index, 'children')">-</div>
                                        <span class="mx-3 font-weight-bold">{{info.children}}</span>
                                        <div class="plus" @click="increaseValue(index, 'children')">+</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                      </section>
                        <div class="d-flex justify-content-center align-items-center mt-1">
                            <button type="button" class="mr-5 btn btn-sm btn-outline-danger" @click="addRooms">Add Rooms {{ roomInfo.length + 1 }}+</button>
                            <button type="button" class="btn btn-sm btn-danger" @click="setPassengervalue">Done</button>
                        </div>
                    </div>
                </section>
                <div class="text-center mt-5">
                    <button type="button" :disabled="isLoading" class="btn btn-danger search-btn" @click="searchHotels">
                        <div v-if="isLoading">Please wait...</div>
                        <div v-else>Search Hotels</div>
                    </button>
                </div>
            </div>
        </div>
      </section>
    <div v-if="isLoading" class="loader-12"></div>
    </section>
    
  </section>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import DatePicker from 'v-calendar/lib/components/date-picker.umd';
  import moment from 'moment';
  import comingSoon from '@/components/coming-soon.vue';
  export default {
    components: {
      DatePicker,
      comingSoon
    },
    filters: {
      formatDate(date) {
        return moment(date).format('ddd DD, MMM');
      }
    },
    data:() => ({
      isPassengerData: false,
      isDateOpen: false,
      isHotelLoading: false,
      isLoading: false,
      isDepatureDropdown: false,
      isHotelCityDropdown: false,
      flightForm: [{
        itineraries: [{
          departure: 'test',
          destination: '',
          departureDate: '',
        }],
      }],
      form: {
        destination: '',
        locationId: '',
        hotelId: '',
        checkinDate: '',
        checkoutDate: '',
        rooms: [],
        targetCurrency: 'NGN',
        country: '',
        appPlatform: 1,
      },
      roomInfo: [{
        adults: 0,
        children: 0,
      }],
      roomData: {
        adults: 0,
        children: 0,
      },
      guestTotal: 0,
    }),
    computed:{
      ...mapState('hotel', ['allHotels']),
      filterHotelCity() {
        return this.allHotels.filter(city => {
          return city.cityName.toLowerCase().includes(this.form.destination.toLowerCase());
        }).sort((a, b) => {
          return a.cityName > b.cityName ? 1 : -1;
        });
      },
      routeName() {
        return this.$route.name;
      }
    },
    async mounted() {
      this.isHotelLoading = true;
      try {
        await this.getAllHotels();
        this.isHotelLoading = false;
      } catch(error) {
        this.isHotelLoading = false;
        this.$swal({
          title: 'Oops...',
          text: error.response.data.errors[0],
          type: 'error',
          confirmButtonText: 'Ok',
        });
      }
    },
    methods: {
      ...mapActions('hotel', ['getAllHotels', 'searchHotel']),
      addRooms() {
        this.roomInfo.push({
          adults: this.roomData.adults,
          children: this.roomData.children,
        });
      },
      deleteRoom(index) {
        if (this.roomInfo.length > 1) {
          this.roomInfo.splice(index, 1);
        }
      },
      increaseValue(index, type) {
        switch (type) {
        case 'adults':
          this.roomInfo[index].adults++;
          break;
        case 'children':
          this.roomInfo[index].children++;
          break;
        default:
          break;
        }
      },
      decreaseValue(index, type) {
        switch (type) {
        case 'adults':
          if(this.roomInfo[index].adults > 0) {
            this.roomInfo[index].adults--;
          }
          break;
        case 'children':
          if(this.roomInfo[index].children > 0) {
            this.roomInfo[index].children--;
          }
          break;
        default:
          break;
        }
      },
      setValue(value) {
        this.form.locationId = value.cityId;
        this.form.destination = value.cityName;
        this.form.country = value.countryName;
        this.isHotelCityDropdown = false;
      },
      toggleDropDown() {
        this.isHotelCityDropdown = !this.isHotelCityDropdown;
      },
      deleteFormRow(index) {
        if (this.flightForm.length > 1) {
          this.flightForm.splice(index, 1);
        }
      },
      setDate() {
        this.isDateOpen = false;
      },
      showDateModal() {
        this.isDateOpen = !this.isDateOpen;
        if(this.isPassengerData) {
          this.isPassengerData = false;
        }
      },
      showPassDropdown() {
        this.isPassengerData = !this.isPassengerData;
        if(this.isDateOpen) {
          this.isDateOpen = false;
        }
      },
      setPassengervalue() {
        this.isPassengerData = false;
        this.isDateOpen = false;
        this.guestTotal =  this.roomInfo.reduce((total, room) => {
          total += room.adults + room.children;
          return total;
        }, 0);
        this.roomInfo = this.roomInfo.filter(room => {
          return room.adults > 0 || room.children > 0;
        });
        // push all adults and children to rooms
        const data = [];
        this.roomInfo.forEach(room => {
          data.push({
            adults: room.adults,
            children: room.children,
          });
        });
        // convert each object to single string
        this.form.rooms = data.map(function(item) {
          return Object.keys(item).map(function(key) {
            return item[key];
          }).join(',');
        });
      },
      async searchHotels() {
        if(this.form.destination === '') {
          this.$swal({
            title: 'Oops...',
            text: 'Please select a destination',
            type: 'error',
            confirmButtonText: 'Ok',
          });
        } else if(this.form.checkinDate === '') {
          this.$swal({
            title: 'Oops...',
            text: 'Please select checkin date',
            type: 'error',
            confirmButtonText: 'Ok',
          });
        } else if(this.form.checkoutDate === '') {
          this.$swal({
            title: 'Oops...',
            text: 'Please select checkout date',
            type: 'error',
            confirmButtonText: 'Ok',
          });
        } else if(this.guestTotal < 1) {
          this.$swal({
            title: 'Oops...',
            text: 'Please select number of guests',
            type: 'error',
            confirmButtonText: 'Ok',
          });
        } else {
          this.isLoading = true;
          const data = {
            ...this.form,
            checkinDate: moment(this.form.checkinDate).format('YYYY-MM-DD'),
            checkoutDate: moment(this.form.checkoutDate).format('YYYY-MM-DD'),
          };
          try {
            const response = await this.searchHotel(data);
            this.isLoading = false;
            const hotelList = response.data.hotelList;
            if (hotelList.length > 0) {
              this.$router.push({ name: 'hotel-search', params: { destination: this.form.destination } });
            } else {
              this.$swal({
                title: 'Oops...',
                text: 'No hotel found',
                type: 'error',
                confirmButtonText: 'Ok',
              });
            }
          } catch(error) {
            this.isLoading = false;
            this.$swal({
              title: 'Oops...',
              text: error.response.data.errors[0],
              type: 'error',
              confirmButtonText: 'Ok',
            });
          }
        }
      },
      resetForm() {
        this.form.itineraries = [];
        this.returnDeparture = '';
        this.returnDestination = '';
        this.returnDepartureDate = '';
        this.itineraries = {
          departure: '',
          destination: '',
          departureDate: '',
          returnDate: '',
        };
        this.isLoading = false;
        this.searchDeparture = '';
        this.hotelCity = '';
        this.form.adults = 0;
        this.form.children = 0;
        this.form.infants = 0;
        this.form.ticketclass = 'Y';
        this.flightForm = [{
          flightSearchType: 'Return',
          ticketclass: 'Y',
          adults: 0,
          children: 0,
          infants: 0,
          targetCurrency: 'NGN',
          appPlatform: 1,
          itineraries: {
            departure: '',
            destination: '',
            departureDate: '',
            returnDate: '',
          }
        }];
      }
    },
  };
</script>

<style scoped>
.page__header--text {
    position: relative;
    z-index: 999;
}
.hotel-text-div {
    width: 100px;
    margin: 0 auto;
}
.hotel-text {
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    border-bottom: 2px solid #E41617;
}
.text-going {
    color: #697886;
    font-size: 14px;
    font-weight: 400;
}
.text-room {
    color: #697886;
    font-size: 13px;
}
p {
    letter-spacing: 0;
}
.airport-wraper {
    width: 288px;
    height: 300px;
    background: white;
    overflow-y: scroll;
    position: absolute;
    left: 6.3rem;
    top: 10rem;
    padding: 0px 20px 20px 20px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}
.airport-wraper-return {
    width: 288px;
    height: 300px;
    background: white;
    overflow-y: scroll;
    position: absolute;
    left: 6.2rem;
    top: 16.5rem;
    padding: 0px 20px 20px 20px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}
.airport-wraper-destination {
    width: 239px;
    height: 300px;
    background: white;
    overflow-y: scroll;
    position: absolute;
    left: 11%;
    top: 10rem;
    padding: 0px 20px 20px 20px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}
.airport-wraper-destination-return {
    width: 288px;
    height: 300px;
    background: white;
    overflow-y: scroll;
    position: absolute;
    left:36.4%;
    top: 16.5rem;
    padding: 0px 20px 20px 20px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}

.page-home {
    box-sizing: border-box;
    background:rgba(0, 0, 0, 0.5)url(../../../assets/TAJimages/hotels/hotel-bg.png);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 100%;
    padding-bottom: 20rem;
}
.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
}
.page__header {
    padding-top: 60px;
}
.page__header h5 {
    font-size: 21px;
    letter-spacing: 0px;
    color: #FFFFFF;
    font-weight: 300;
}
.page__header h4 {
    font-size: 23px;
    letter-spacing: 0px;
    color: #FFFFFF;
    font-weight: 500;
    opacity: 1;
    padding-top: 24px;
}
.search__section--wrapper {
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 10px;
    opacity: 1;
    backdrop-filter: blur(7px);
    -webkit-backdrop-filter: blur(7px);
    width: 100%;
    height: 100%;
    margin-top: 50px;
    padding: 40px 50px;
}
.flight-from {
    width: 240px;
    height: 100%;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: inset 0px 3px 6px #00000029;
    border: 1px solid #CCCCCC;
    border-radius: 10px;
    opacity: 1;
    cursor: pointer;
}
.flight-text h6 {
    font-size: 15px;
    margin-bottom: 0;
}
.flight-text h5 {
    font-size: 18px;
    margin-bottom: 0;
    font-weight: bold;
}
.flight-text p {
    font-size: 12px;
    margin-bottom: 0;
    font-weight: 100;
}
.flight-date {
    background: #242B38;
    box-shadow: inset 0px 3px 6px #00000029;
    border-radius: 5px;
    opacity: 1;
    color: #fff;
    width: 200px;
    height: 78px;
    font-size: 17px;
    font-weight: 500;
    cursor: pointer;
}
.flight-type {
    margin-left: 8px;
    width: 220px;
    height: 78px;
    background: #FFF1E0 0% 0%;
    box-shadow: inset 0px 3px 6px #00000029;
    border-radius: 5px;
    color: #fff;
    padding: 20px;
    cursor: pointer;
}
.flight-type-multi {
    height: 78px;
    background: #242B38 0% 0%;
    box-shadow: inset 0px 3px 6px #00000029;
    border-radius: 10px;
    color: #fff;
    padding: 20px;
    cursor: pointer;
    padding: 0 30px;
}
.text-cabin {
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 5px;
    color: #697886;
}
.text-eco {
    font-size: 15px;
    font-weight: 500;
    margin-bottom: 5px;
    color: #fff;
}
.text-class {
    font-size: 13px;
    font-weight: 100;
    margin-bottom: 0;
    color: #fff;
}
.text-number {
    position: absolute;
    top: -5px;
    left: 105px;
}
.refresh {
    position: absolute;
    background: #232B38;
    padding: 8px;
    border-radius: 50%;
    left: 34%;
}
.multi-way {
    left: 43% !important;
}
.search-btn {
    height: 50px;
    max-width: 200px;
    width: 200px;
}
.flight-type-menu {
    position: absolute;
    right: 40px;
    top: 60%;
    width: 340px;
    /* height: 100%; */
    padding: 20px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 30px #0000001A;
    border-radius: 10px;
    opacity: 1;
}
.select--menu label{
    text-align: left;
    font-size: 14px;
    letter-spacing: 0px;
    color: #232949;
    opacity: 1;
}
.pass-section {
    margin-top: 5px;
}
.pass-section h4 {
    text-align: center;
    font-size: 18px;
    letter-spacing: 0px;
    color: #232949;
    opacity: 1;
    margin-bottom: 30px;
}
.minus {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    background: #F0F0F0 0% 0% no-repeat padding-box;
    border-radius: 7px;
    opacity: 1;
    font-size: 17px;
    font-weight: 500;
    cursor: pointer;
}
.plus {
    color: #E41617;
    background: #FAE1DC;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 7px;
    opacity: 1;
    font-size: 17px;
    font-weight: 500;
    cursor: pointer;
}
.pass-text h4 {
    font-size: 18px;
    letter-spacing: 0px;
    color: #020202;
    margin-bottom: 5px;
}
.pass-text p {
    font-size: 13px;
    letter-spacing: 0px;
    color: #9B9AAC;
    margin-bottom: 0;
    font-weight: 100;
}
div >>> .vs__dropdown-toggle {
    width: 200px !important;
    max-width: 200px !important;
    border: 0 !important;
}
.button__section {
    position: relative;
}
.date-wrapper {
    background: #fff;
    padding: 20px;
    z-index: 999;
    width: 580px;
    max-width: 100%;
    position: absolute;
    top: 55%;
    right: 23%;
}
.btn-custom {
    background: #FFF4F2;
    color: #E41617;
    border-radius: 7px;
    font-weight: 500;
    font-size: 17px;
    width: 150px;
}
.search-form {
    padding: 10px 10px 10px 9px;
    width: 150px;
    border: 0;
    font-size: 17px;
}
.search-form::placeholder {
    color: #020202 !important;
}
.text-remove {
  color: #F58220;
  font-size: 13px;
  font-weight: 300;
  cursor: pointer;
}
</style>